angular.module('leanlaw').controller('ApiKeyModalController', ['$scope', 'close', 'apiKey', 'alerts', function ($scope, close, apiKey, alerts) {
  $scope.vm = {
    key: {
      ...apiKey
    },
    action: apiKey.id ? 'Edit' : 'Create',
    scopeTemplate: [{
      id: 'billable',
      label: 'Billables: Time, Expenses, Fees'
    }, {
      id: 'client',
      label: 'Clients'
    }, {
      id: 'matter',
      label: 'Matters'
    }, {
      id: 'financials',
      label: 'Financials: Invoices, Payments, Client Balances, Rates'
    }, {
      id: 'user',
      label: 'Users (read-only)',
      hideWriteOption: true
    }],
    scope: []
  };
  deserializeScope = function (rawScope) {
    // at this point scope is an array of strings eg: ['billable.read', 'user.read']
    // this method deserialize scope to an array of scope objects
    // let scope = $scope.vm.scopeTemplate.map(s => ({...s}));
    if (!rawScope) {
      return $scope.vm.scopeTemplate.map(s => ({
        ...s,
        read: true,
        write: !s.hideWriteOption
      }));
    }
    rawScope.forEach(r => {
      const [entity, access] = r.split('.');
      const scopeObject = $scope.vm.scopeTemplate.find(s => s.id === entity);
      if (scopeObject) scopeObject[access] = true;
    });
    return $scope.vm.scopeTemplate;
  };
  serializeScope = function (scope) {
    let resultScope = [];
    scope.forEach(s => {
      if (s.read === true) resultScope.push(`${s.id}.read`);
      if (s.write === true) resultScope.push(`${s.id}.write`);
    });
    return resultScope;
  };
  $scope.vm.scope = deserializeScope($scope.vm.key.scope);
  $scope.confirm = function () {
    if ($scope.vm.key.label === undefined || $scope.vm.key.label === '') {
      alerts.error('Label is required');
      return;
    }
    $scope.vm.key.scope = serializeScope($scope.vm.scope);
    close($scope.vm.key);
  };
  $scope.cancel = function () {
    close(false);
  };
  $scope.readAccessChanged = function (scope) {
    if (scope.read === false) scope.write = false;
  };
  $scope.writeAccessChanged = function (scope) {
    if (scope.write === true) scope.read = true;
  };
}]);